module.exports = __webpack_public_path__ + "static/media/Noivern_gaussian2.296cb4e6.png";